import React, { useContext, useState } from 'react';
import { FaFireAlt } from 'react-icons/fa';
import { FaFireFlameSimple } from 'react-icons/fa6';
import { BsFire } from 'react-icons/bs';
import { FaExclamationCircle } from 'react-icons/fa';
import { FaLongArrowAltDown } from 'react-icons/fa';
import { FaLongArrowAltUp } from 'react-icons/fa';
import moment from 'moment';
import { ColorContext, LayoutSizeContext } from 'App';

export const FireDangerDay = ({ data, index, widgetInfo, vertical, spacing, compact = false }) => {
  const [expanded, setExpanded] = useState(true);

  const layout = useContext(LayoutSizeContext);
  const theme = useContext(ColorContext);

  const fireIcons = {
    0: <FaFireFlameSimple size={64} />,
    1: <FaFireAlt size={64} />,
    2: <BsFire size={64} />,
    3: <BsFire size={64} />,
    4: <BsFire size={64} />,
  };

  return widgetInfo ? (
    <div className="w-100">
      <div
        className="d-flex align-items-start w-100"
        style={{
          flexDirection: vertical ? 'column' : 'row',
          gap: spacing ?? (compact ? 6 : 8),
          flexWrap: compact && !vertical ? 'wrap' : 'nowrap',
          justifyContent: vertical ? 'flex-start' : compact ? 'flex-start' : 'space-around',
          fontSize: compact ? '0.9rem' : undefined,
          lineHeight: compact ? 1.1 : undefined,
        }}
      >
        <div
          className={compact ? '' : 'mt-2'}
          style={{
            minWidth: 0,
            flex: vertical ? '1 1 auto' : compact ? '1 1 170px' : '0 1 auto',
            overflowWrap: 'anywhere',
          }}
        >
          <FaExclamationCircle /> Risk Level: {data['level']}
        </div>
        <div
          className={compact ? '' : 'mt-2'}
          style={{
            minWidth: 0,
            flex: vertical ? '1 1 auto' : compact ? '1 1 170px' : '0 1 auto',
            overflowWrap: 'anywhere',
          }}
        >
          <FaLongArrowAltUp /> Upper Soil Moisture: {data['upper_soil_moisture']}
        </div>
        <div
          className={compact ? '' : 'mt-2'}
          style={{
            minWidth: 0,
            flex: vertical ? '1 1 auto' : compact ? '1 1 170px' : '0 1 auto',
            overflowWrap: 'anywhere',
          }}
        >
          <FaLongArrowAltDown /> Lower Soil Moisture: {data['lower_soil_moisture']}
        </div>
      </div>
    </div>
  ) : (
    <div className="bg-base p-3">
      <div
        className="h4 border-1 border-bottom border-light-subtle justify-content-between d-flex"
        onClick={() => setExpanded(!expanded)}
      >
        {moment(data.utc_time).format('MM/DD/YYYY')}
        <button>{data['level']}</button>
      </div>
      {expanded && (
        <div className="d-flex justify-content-between">
          <div>
            <div className="mt-2">
              <FaExclamationCircle /> {data['level']}
            </div>
            <div className="mt-2">
              <FaLongArrowAltUp /> Upper Soil Moisture: {data['upper_soil_moisture']}
            </div>
            <div className="mt-2">
              <FaLongArrowAltDown /> Lower Soil Moisture: {data['lower_soil_moisture']}
            </div>
          </div>

          <div className="mt-2">{fireIcons[data['danger_level']]}</div>
        </div>
      )}
    </div>
  );
};
